// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading div {
  width: 20px;
  height: 20px;
  background: #0d85bd;
  border-radius: 50%;
  animation: cycle 1s ease-in-out infinite;
}

.loading div:nth-child(1) {
  animation-delay: 0;
}

.loading div:nth-child(2) {
  animation-delay: 0.2s;
  margin: 0 10px;
}

.loading div:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes cycle {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(1rem);
  }

  100% {
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/loader-overlay/loader-overlay.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".loading div {\n  width: 20px;\n  height: 20px;\n  background: #0d85bd;\n  border-radius: 50%;\n  animation: cycle 1s ease-in-out infinite;\n}\n\n.loading div:nth-child(1) {\n  animation-delay: 0;\n}\n\n.loading div:nth-child(2) {\n  animation-delay: 0.2s;\n  margin: 0 10px;\n}\n\n.loading div:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes cycle {\n  0% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(1rem);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
